import { useState, useEffect } from "react";
import { loadDepartment } from "../services/departmentService";
import { loadStorageLocation } from "../services/storageLocationService";

const useStorageLocation = (editShiftAssignmentID) => {
    const [storageLocation, setStorageLocation] = useState([]);
    const [selectedStorageLocation, setSelectedStorageLocation] = useState(null);
    const [selectedStorageLocationID, setSelectedStorageLocationID] = useState(null);
    const [isDepartmentDataLoaded, setIsDepartmentDataLoaded] = useState(false);

    // Fetch department data
    const fetchStorageLocation = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadStorageLocation(para);
            if (data && data.length > 0) {
                setStorageLocation(data);

                // const initialDepartment = data.find((dept) => dept.id === selectedID) || data[0];
                const initialStorageLocation = data.find((dept) => dept.id === selectedID);
                if (initialStorageLocation?.length > 0) {
                    setSelectedStorageLocation(initialStorageLocation);
                    setSelectedStorageLocationID(initialStorageLocation.id);
                    setIsDepartmentDataLoaded(true);
                }

            }

        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isDepartmentDataLoaded && editShiftAssignmentID === 0) {
            fetchStorageLocation();
        }
    }, [isDepartmentDataLoaded, editShiftAssignmentID]);

    // Function to load department based on selected ID
    const loadStorageLocationByID = async (selectedID) => {
        await fetchStorageLocation(selectedID);
    };

    return {
        storageLocation,
        selectedStorageLocation,
        selectedStorageLocationID,
        setSelectedStorageLocation,
        setSelectedStorageLocationID,
        loadStorageLocationByID,
    };
};

export default useStorageLocation;
